import React from "react";
import DownloadReportButton from "../../../components/common/DownloadReportButton";
import { useBoolean } from "../../../Hooks/useBoolean";
import { useDispatch } from "react-redux";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import { tripMasterReportAsync } from "../../../redux/features/reportSlice";
import moment from "moment";
import {
   calculateFormattedTimeDifference,
   calculateTimeDifference,
} from "../../../helpers/calculateTimeDifference";
import { areAllNumbers, calculateDetentionRate, subtractNumbers } from "../../../helpers";
import { calculateFieldValueSum } from "../../../helpers/getTripExtrasFieldSum";
import { calculateNumberDifference } from "../../../helpers/calculateNumberDifference copy";
import * as XLSX from "xlsx";

const MISReport = () => {
   const dispatch = useDispatch();

   const reportPopup = useBoolean();

   const handleDownloadReport = (data, callback) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         tripMasterReportAsync({
            data: data,
            params: {
               ...(data?.customerNames?.length > 0 && {
                  customer_names: data?.customerNames,
               }),
               ...(data?.customerName && { customer_name: data?.customerName }),
            },
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Vehicle No.",
                  "Vehicle Category",
                  "Trip Created By",
                  "Entry Date",
                  "Driver Name",
                  "Driver No.",
                  "Customer Name",
                  // "Origin Company Name",
                  "Origin Address",
                  // "Destination Company Name",
                  "Destination Address",
                  "Lane Name",
                  "Vehicle Reported Date Time (Origin)",
                  "Vehicle Dispatch Date Time (Origin)",
                  "Invoice No.",
                  "Invoice Date",
                  "Invoice Value",
                  "E Waybill No.",
                  "E Waybill Expiry Date & Time",
                  "Customer / Eisaku LR No.",
                  "LR Date",
                  "Destination Reported Date Time",
                  "Destination Unloading Date Time",
                  "TAT (in Hrs)",
                  "Holding Time at Origin",
                  "Holding Time at Destination",
                  "POD Received Date",
                  "POD Submit Date",
                  "Driver Trip Advance Budget",
                  "Actual Driver Trip Advance",
                  "Driver Trip Advance Variance (Actual - Budget)",
                  "Extra Driver Tip",
                  "Trip Diesel Budget (ltr)",
                  "Actual Diesel Provided",
                  "Trip Diesel Variance (Actual - Budget)",
                  "Extra Trip Diesel",
                  "AdBlue Budget",
                  "Actual AdBlue Provided",
                  "Trip AdBlue Variance (Actual - Budget)",
                  "Extra Adblue",
                  "Actual Miscellaneous Expense (1,2,3… Multiple Addition Required)",
                  "Total Actual Miscellaneous Expense (1+2+3…)",
                  "Extra Miscellaneous Charges",
                  "Budget Trip Toll",
                  // "Actual Trip Toll",
                  // "Trip Toll Variance (Actual - Budget)",
                  "From Customer Trip Rate",
                  "From Vendor Trip Rate",
                  "Express Mode Rate Additional",
                  "Super Express Mode Rate Additional",
                  "Detention Rate Additional",
                  "Multiple Loading Location Rate Additional",
                  "Multiple Unloading Location Rate Additional",
                  "Loading Charges",
                  "Unloading Charge",
                  "Miscellaneous Charges",
                  "Miscellaneous Remarks",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
               ];

               // const lineBreak = [
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               //    "********",
               // ];

               const formatDate = (date, withTime = false) =>
                  date
                     ? moment(date).format(
                          withTime ? "DD-MM-YYYY HH:mm:ss" : "DD-MM-YYYY",
                       )
                     : "-";

               const tripMasterDataArr = [];

               report?.tripMaster?.forEach?.((item, index) => {
                  const arr = [];

                  arr.push(
                     `${index + 1} ${
                        item?.review_status === "rejected" ? " (Rejected)" : ""
                     }`, // S. No.
                     item?.vehicle_no ?? "-", // Vehicle No.
                     item?.vehicle_category_name ?? "-", // Vehicle Category
                     item?.created_by_name ?? "-", // Trip Created By
                     formatDate(item?.trip_created_at, true), // Entry Date
                     item?.drivername ?? "-", // Driver Name
                     item?.driverno ?? "-", // Driver No.
                     item?.customername ?? "-", // Customer Name
                     // item?.origin_company_name ?? "-", // Origin Company Name
                     item?.lane_masters?.origin_location_master?.name ?? "-", // Origin Address
                     // item?.destination_company_name ?? "-", // Destination Company Name
                     item?.lane_masters?.destination_location_master?.name ?? "-", // Destination Address
                     item?.lane_masters?.name ?? "-", // Lane Name
                     formatDate(item?.vehicle_reported_date, true), // Vehicle Reported Date Time (Origin)
                     formatDate(item?.vehicle_disptch_date, true), // Vehicle Dispatch Date Time (Origin)
                     item?.invoice_no ?? "-", // Invoice No.
                     formatDate(item?.invoice_date, true), // Invoice Date
                     item?.invoice_value ?? "-", // Invoice Value
                     item?.ewaybillno ?? "-", // E Waybill No.
                     formatDate(item?.ewaybill_expiry_date, true), // E Waybill Expiry Date & Time
                     item?.customer_lrno ?? "-", // Customer / Eisaku LR No.
                     formatDate(item?.trip_created_at), // LR Date
                     formatDate(item?.destination_reported_date, true), // Destination Reported Date Time
                     formatDate(item?.destination_unloading_date, true), // Destination Unloading Date Time
                     item?.trip_status === "closed"
                        ? calculateFormattedTimeDifference(
                             item?.destination_reported_date,
                             item?.vehicle_disptch_date,
                          )
                        : "-", // TAT (in Hrs)

                     calculateFormattedTimeDifference(
                        item?.vehicle_disptch_date,
                        item?.vehicle_reported_date,
                     ) ?? "-", // Holding Time at Origin

                     calculateFormattedTimeDifference(
                        item?.destination_unloading_date,
                        item?.destination_reported_date,
                     ) ?? "-", // Holding Time at Destination
                     item?.trip_status === "closed"
                        ? formatDate(item?.trip_updated_at)
                        : "", // POD Received Date
                     formatDate(item?.trip_created_at), // POD Submit Date
                     item?.lane_masters?.trip_advance ?? "-", // Driver Trip Advance Budget
                     item?.actual_driver_trip_advance ?? "-", // Actual Driver Trip
                     areAllNumbers(
                        item?.lane_masters?.trip_advance,
                        item?.actual_driver_trip_advance,
                     )
                        ? subtractNumbers(
                             item?.lane_masters?.trip_advance,
                             item?.actual_driver_trip_advance,
                          )
                        : "-", // Driver Trip Advance Variance (Actual - Budget)
                     "-",
                     item?.lane_masters?.diesel_rate ?? "-", // Trip Diesel Budget (ltr)
                     item?.actual_diesel_provided ?? "-", // Actual Diesel Provided
                     areAllNumbers(
                        item?.lane_masters?.diesel_rate,
                        item?.actual_diesel_provided,
                     )
                        ? subtractNumbers(
                             item?.lane_masters?.diesel_rate,
                             item?.actual_diesel_provided,
                          )
                        : "-", // Trip Diesel Variance (Actual - Budget)
                     "-",
                     item?.adblue_rate ?? "-", // AdBlue Budget
                     item?.actual_adblue_provided ?? "-", // Actual AdBlue Provided
                     areAllNumbers(
                        item?.lane_masters?.adblue_rate,
                        item?.actual_adblue_provided,
                     )
                        ? subtractNumbers(
                             item?.lane_masters?.adblue_rate,
                             item?.actual_adblue_provided,
                          )
                        : "-", // Trip AdBlue Variance (Actual - Budget)
                     "-",
                     item?.extras?.[0]?.field_value ?? "-", // Actual Miscellaneous Expense
                     calculateFieldValueSum(item?.extras) ?? "-", // Total Miscellaneous Expense
                     "-",
                     item?.trip_toll_budget ?? "-", // Budget Trip Toll
                     // item?.trip_toll ?? "-", // Actual Trip Toll
                     // item?.sss ?? "-", // Trip Toll Variance
                     item?.cust_trip_rate ?? "-", // From Customer Trip Rate
                     item?.vend_trip_rate ?? "-", // From Vendor Trip Rate
                     item?.cust_express_mode_rate_additional ?? "-", // Express Mode Rate Additional
                     item?.cust_super_express_mode_rate_additional ?? "-", // Super Express Mode Rate Additional
                     areAllNumbers(
                        Math.abs(
                           calculateTimeDifference(
                              item?.destination_unloading_date,
                              item?.destination_reported_date,
                           ),
                        ),
                     )
                        ? calculateDetentionRate(
                             Math.abs(
                                calculateTimeDifference(
                                   item?.destination_unloading_date,
                                   item?.destination_reported_date,
                                ),
                             ),
                          )
                        : "-", // Detention Rate Additional
                     item?.cust_multiple_loading_location_rate_additional ?? "-", // Multiple Loading Location Rate Additional
                     item?.cust_multiple_unloading_location_rate_additional ?? "-", // Multiple Unloading Location Rate Additional
                     item?.cust_loading_charges ?? "-", // Loading Charges
                     item?.cust_unloading_charge ?? "-", // Unloading Charge
                     item?.cust_miscellaneous_charges ?? "-", // Miscellaneous Charges
                     item?.cust_miscellaneous_remarks ?? "-", // Miscellaneous Remarks
                  );

                  tripMasterDataArr.push(arr);
               });

               const sheetData = [
                  headers,
                  ...tripMasterDataArr,
                  // lineBreak,
                  // ...adhocTripMasterDataArr,
               ];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "MIS_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               callback?.();
               reportPopup.onFalse();
            },
         }),
      );
   };

   return (
      <DownloadReportButton
         onDownloadReport={handleDownloadReport}
         confirmPopup={reportPopup}
         needCustomerFilter={true}
      />
   );
};

export default MISReport;
